<template id="rezervari">
    <div class="rezervari" data-app :key="current_page">
        <div class="content">

            <div class="left-content">
                <div class="header">
                    <div v-for="page in pages" :key="page.page_number"
                        :class="page.completed ? 'steps-active' : 'steps-inactive'"></div>
                </div>
                <div class="main">
                    <img :src="getImgUrl(pages[current_page].src)">
                    <h1>{{ pages[current_page].title }}</h1>
                    <h3>{{ pages[current_page].description }}</h3>
                </div>
                <div class="footer">
                    <h1>Intrebari?</h1>
                    <h3>Suna la 0754 00 44 00</h3>
                    <h1 v-if="this.AgentLogat">Agent: <span style="color:red;">{{ NumeAgent }}</span></h1>
                </div>
            </div>
            <!-- alege serviciu -->
            <div class="center-content" v-if="current_page === 0">
                <div class="header">
                    <h1>Alege serviciul</h1>
                </div>
                <div class="main">
                    <div v-for="serviciu of servicii" :key="'serviciu' + serviciu.Id + serviciu.Nume"
                        @click="alege_serviciu(serviciu)"
                        :class="`select-container ${serviciu_selectat.id == serviciu.Id ? 'select-container-active' : ''}`">
                        <div class="img-div">
                            <img :src="serviciu.Iconita" :alt="serviciu.Nume" />
                        </div>
                        <div class="serviciu">
                            <h1>{{ serviciu.Nume }}</h1>
                            <h4>{{ serviciu.Descriere }}</h4>
                        </div>
                        <!-- <div class="pret">
                            <h1>{{serviciu.Pret}} Lei</h1>
                            <h4>Pret incepand de la</h4>
                        </di>v -->
                    </div>

                </div>
                <div class="footer">
                    <el-button v-if="serviciu_selectat.id != null && Roti.checked" @click="next_page()">
                        <template>
                            Pasul urmator <i class="el-icon-right"></i>
                        </template>
                    </el-button>
                </div>
            </div>

            <div class="center-content" v-if="current_page === 1">

                <div class="header">
                    <h1>Sursa si destinatia anvelopelor ( {{ Roti.nr_roti }} buc.)</h1>
                </div>
                <div class="main-sursa-destinatie">
                    <el-card class="roti-container">
                        <template #header>
                            <div class="titlu-roti">
                                <p>{{ Roti.TitluSursa }}</p>
                            </div>
                        </template>
                        <div class="continut-roti-scrollable">
                            <el-form label-position="top">
                                <el-row :gutter="15">
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelSursaHotel }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.cantitate_depozitare_hotel"
                                                placeholder="Selecteaza cantitatea depozitata in hotel">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelSursaPersonal }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.cantitate_depozitare_personala"
                                                placeholder="Selecteaza cantitatea depozitata in maniera personala">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelSursaComanda }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.cantitate_depozitare_comanda"
                                                placeholder="Selecteaza cantitatea depozitata sub forma de comanda">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col v-if="Roti.cantitate_depozitare_comanda > 0" :md="24">
                                        <el-form-item>
                                            <template #label>
                                                <div style="display:flex;gap:6px;align-items:center">
                                                    <span>Numar comanda</span>
                                                    <el-tooltip class="item" effect="dark"
                                                        content="Introduceti numarul comenzii" placement="top-start">
                                                        <i class="el-icon-info"></i>
                                                    </el-tooltip>
                                                </div>
                                            </template>
                                            <el-tag :key="tag" v-for="tag in nrComandaTags" closable
                                                :disable-transitions="false" @close="handleClose(tag)"> {{ tag
                                                }}</el-tag>
                                            <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue"
                                                ref="saveTagInput" size="mini" @keyup.enter.native="handleInputConfirm"
                                                @blur="handleInputConfirm"></el-input>
                                            <el-button v-else class="button-new-tag" size="small" @click="showInput">+
                                                Numar
                                                comanda</el-button>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>

                        </div>
                    </el-card>
                    <el-card class="roti-container">
                        <template #header>
                            <div class="titlu-roti">
                                <p>{{ Roti.TitluDestinatie }}</p>
                            </div>
                        </template>
                        <div class="continut-roti-scrollable">
                            <el-form label-position="top">
                                <el-row :gutter="15">
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelDestinatieReciclare }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.destinatie_reconditionare"
                                                placeholder="Selecteaza cantitatea pentru reciclare">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelDestinatieHotel }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.destinatie_hotel"
                                                placeholder="Selecteaza cantitatea pentru hotel">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :md="24">
                                        <el-form-item>
                                            <template #label>
                                                {{ Roti.LabelDestinatieReturnare }}
                                            </template>
                                            <el-select class="full-width" v-model="Roti.destinatie_returnare"
                                                placeholder="Selecteaza cantitatea pentru returnare">
                                                <el-option v-for="cantitate in cantitate_optiuni" :key="cantitate.value"
                                                    :label="cantitate.label" :value="cantitate.value">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </el-form>
                        </div>
                    </el-card>
                </div>
                <div class="footer-ora">
                    <div class="content-footer">
                        <a style="white-space:nowrap" @click="next_page()"><i class="el-icon-right"></i> Urmatorul
                            pas</a>
                        <span size="small" style="display: flex;align-items: center; gap:6px;" plain type="primary" @click="overrideStep()" v-if="current_page == 1">Sari
                            peste<i class="el-icon-d-arrow-right"></i>
                        </span>

                    </div>
                </div>
            </div>

            <!-- alege ora -->
            <div class="center-content" v-if="current_page === 2">

                <div class="header">
                    <h1>Alege Data si Ora</h1>
                </div>
                <div class="main-ora">
                    <div class="nav">
                       <el-button @click="previous_month()" :disabled="loader" icon="el-icon-arrow-left"></el-button>
                        <p>{{ luna_selectata.nume }} <span>{{ an_selectat }}</span></p>
                       <el-button @click="next_month()" :disabled="loader" icon=" el-icon-arrow-right"></el-button>
                    </div>
                    <div class="container-program">
                        <div class="program" v-loading="loader">
                            <div class="header">LUN</div>
                            <div class="header">MAR</div>
                            <div class="header">MIE</div>
                            <div class="header">JOI</div>
                            <div class="header">VIN</div>
                            <div class="header header-weekend">SAM</div>
                            <div class="header header-weekend">DUM</div>
                            <div v-for="(value, index) of Program" :key="index + value" class="zi"
                                :style="(value[1].ziua_saptamanii == '0' || value[1].ziua_saptamanii == '6') ? 'background-color: #FCFEF1' : ''">
                                <div href="#ore" @click="select_date(value)"
                                    :class="value[1].count_intervale_libere == 0 && value[1].count_intervale_libere == value[1].count_intervale_ocupate ? 'button-zi-indisponibila' :
                                        value[1].count_intervale_libere > 0 ? value[1].luna_curenta == 1 ? 'button-zi-disponibila' : 'button-zi-disponibila_nu_in_luna_curenta' : 'button-zi-indisponibila'">
                                    {{ get_day(value[0]) }}
                                    <div v-if="value[1].count_intervale_libere > 0 && value[1].intervale"
                                        class="bara-liber">
                                        <div v-for="(v, i) of value[1].intervale" :key="'interval' + i"
                                            :class="v.liber ? 'liber' : 'ocupat'"></div>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div id="ore" class="ore" v-if="selectedObject.data != undefined">
                            <p><span class="bara">Alege ora programarii pentru <span class="data">{{ selectedObject.data
                            }}</span></span></p>
                            <div class="butoane">
                                <div v-for="(value, index) of selectedObject.data_object.intervale" :key="'ora' + index"
                                    :class="value.liber ? 'liber' : 'ocupat'" @click="select_hour(value)">
                                    {{ index }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="footer-ora">
                    <div class="content-footer">
                        <a @click="previous_page()"><i class="el-icon-back"></i> Inapoi</a>
                    </div>
                </div>
            </div>

            <div class="center-content" v-if="current_page === 3">
                <div class="header">
                    <h1>Date de contact</h1>
                </div>
                <div class="main-formular" v-loading="loader">
                    <div v-if="this.AgentLogat" class="">
                        <el-button size="small" type="warning" @click="deschide_dialog_alege_client()">Alege client -
                            masina</el-button>
                    </div>
                    <div v-else class="titlu-formular">
                        <h1 @click="schimba_tip_client(0)" :class="tip_cont.client_nou ? 'selectat' : false">Client Nou
                        </h1>
                        <h1 style="text-align: end" @click="schimba_tip_client(1)"
                            :class="tip_cont.client_vechi ? 'selectat' : ''">
                            Ai mai fost la noi?</h1>
                    </div>
                    <div class="formular">
                        <v-form @submit.native.prevent="save()" lasy-validation class="formular" label-position="top"
                            :inline="false" label-width="100%" :model="selectedObject.Data" :rules="rules"
                            :ref="'my-form'">
                            <el-row class="rand">
                                <el-col class="coloana">
                                    <!-- <el-input v-model="Data.Nume" placeholder="Introdu numele"></el-input> -->
                                    <v-text-field dense label="Nume" v-model="selectedObject.Data.Nume" outlined
                                        :rules="[rules_vuetify.required, rules_vuetify.nume]"></v-text-field>
                                </el-col>
                                <el-col class="coloana">
                                    <v-text-field dense label="Prenume" v-model="selectedObject.Data.Prenume" outlined
                                        :rules="[rules_vuetify.required, rules_vuetify.prenume]"></v-text-field>
                                </el-col>
                            </el-row>
                            <el-row class="rand">
                                <el-col class="coloana">
                                    <v-text-field dense label="Telefon" v-model="selectedObject.Data.Telefon" outlined
                                        oninvalid="this.setCustomValidity('Completeaza acest camp')"
                                        :rules="[rules_vuetify.required, rules_vuetify.telefon]"></v-text-field>
                                </el-col>
                                <el-col class="coloana">
                                    <v-text-field v-show="!Boolean(NoEmail)" :disabled="Boolean(NoEmail)" dense
                                        label="Email" v-model="selectedObject.Data.Email" outlined
                                        oninvalid="this.setCustomValidity('Completeaza acest camp')"
                                        :rules="[rules_vuetify.email]"></v-text-field>

                                    <v-text-field v-if="Boolean(NoEmail)" onCopy="return false" onDrag="return false"
                                        onDrop="return false" onPaste="return false" placeholder="noemail@anvelope.ro"
                                        dense v-model="selectedObject.Data.NoEmailTastat" outlined
                                        oninvalid="this.setCustomValidity('tasteaza noemail@anvelope.ro')"
                                        :rules="[rules_vuetify.noemailrule]"></v-text-field>

                                    <v-checkbox v-if="this.AgentLogat" label="clientul nu are email" v-model="NoEmail"
                                        color="red" hide-details value="1" @change="bifa_no_email()"></v-checkbox>


                                </el-col>
                            </el-row>
                            <el-row class="rand">
                                <el-col class="coloana">
                                    <v-text-field dense label="Numar masina" v-model="selectedObject.Data.Numar"
                                        @change="format_numar()" hint="Ex: B123ABC" outlined
                                        :rules="[rules_vuetify.required, rules_vuetify.numar]"></v-text-field>
                                </el-col>
                                <el-col class="coloana">
                                    <v-text-field pattern="[0-9]*" inputmode="numeric" dense label="Numar kilometri"
                                        v-model="selectedObject.Data.Km" :rules="[rules_vuetify.km]"
                                        outlined></v-text-field>
                                </el-col>
                            </el-row>
                            <el-row class="rand">
                                <el-col class="coloana">
                                    <!-- <v-text-field
                            dense
                            label="Marca"
                            v-model="selectedObject.Data.Marca"
                            hint="Ex: Dacia"
                            outlined
                            ></v-text-field> -->
                                    <v-autocomplete :items="Marci" :item-text="'Nume'" :item-value="'Id'" label="Marca"
                                        v-model="selectedObject.Data.Marca" dense
                                        @change="load_model_marca(selectedObject.Data.Marca['Id'])" return-object
                                        outlined></v-autocomplete>
                                </el-col>
                                <el-col class="coloana">
                                    <v-autocomplete :items="Model_marci" :item-text="'Nume'" :item-value="'Id'"
                                        label="Model" v-model="selectedObject.Data.Model" dense
                                        :disabled="selectedObject.Data.Marca == '' || selectedObject.Data.Marca == null || selectedObject.Data.Marca.length <= 0"
                                        return-object outlined></v-autocomplete>
                                </el-col>
                            </el-row>
                            <el-row class="rand">
                                <el-col class="an">
                                    <el-date-picker value-format="yyyy" type="year" :picker-options="datePickerOptions"
                                        placeholder="Alegeti anul fabricatiei" v-model="selectedObject.Data.An"
                                        style="margin-bottom: 10px;"></el-date-picker>
                                </el-col>
                            </el-row>
                            <el-row
                                style="width: 100%; display: flex; justify-content: flex-start; padding-top: 22px;font-size: smaller !important;">
                                <v-checkbox v-model="selectedObject.Data.Acord" :rules="[rules_vuetify.required]"
                                    style="">

                                    <template v-slot:label>
                                        <div>
                                            &nbsp; Am citit si sunt de acord cu
                                            <a target="_blank"
                                                :href="'https://' + url + '/#/politica_de_confidentialitate'"
                                                @click.stop>
                                                Politica de confidentialitate
                                            </a>
                                        </div>
                                    </template>
                                </v-checkbox>
                            </el-row>
                        </v-form>

                    </div>
                </div>
                <!-- :disabled="!Boolean(selectedObject.Data.Acord)" -->
                <div class="footer-formular">
                    <a @click="previous_page()"><i class="el-icon-back"></i> Inapoi</a>
                    <el-button @click="save()" :disabled="programareTrimisa || once">
                        <template>
                            Finalizeaza programarea <i class="el-icon-right"></i>
                        </template>
                    </el-button>
                </div>
            </div>
            <div class="right-content">
                <div class="header">
                    <h1><span>Sumar</span></h1>
                </div>
                <div class="main">
                    <div class="element" v-for="s of sumar" :key="s.titlu + '_sumar'">
                        <h3>{{ s.titlu }}</h3>
                        <h1>{{ s.descriere }}</h1>
                    </div>
                </div>
            </div>

        </div>
        <Finalizare ref="finalizare" @goToFirstPage="goToFirstPage()" @close='reload()' @closed="reload()" />
        <el-dialog :close-on-click-modal="true" :close-on-press-escape="true" id="roti" width="350px"
            :visible.sync="Roti.show_nr_roti" :append-to-body="true">
            <div class="roti-container" v-if="depozitare_step == 1 && optiune_cantitati == 'cantitate_bifa_hotel'">
                <div class="titlu-roti">
                    <p>{{ Roti.TextDialog }}</p>
                </div>
                <hr />
                <div class="continut-roti">
                    <el-form label-position="top">
                        <el-row :gutter="15">
                            <el-col :md="24">
                                <el-form-item label="Cantitate totala">
                                    <template #label>
                                        <div style="display:flex;gap:6px;align-items:center">
                                            <span>Cantitate totala</span>
                                        </div>
                                    </template>
                                    <el-input-number :min="1" style="width:75% !important" :value="Roti.nr_roti" v-model="Roti.nr_roti" />
                                </el-form-item>
                            </el-col>
                            <div>
                                <el-checkbox v-if="Roti.TextButonHotel.length > 0" v-model="Roti.hotel">{{
                                    Roti.TextButonHotel
                                }}</el-checkbox>
                            </div>
                        </el-row>
                    </el-form>
                    <div class="footer-roti">
                        <el-button @click="salveaza_roti()">Confirma</el-button>
                    </div>
                </div>
            </div>
            <div class="roti-container" v-if="depozitare_step == 1 && optiune_cantitati == 'sursa_destinatie'">
                <div class="titlu-roti">
                    <p>{{ Roti.TextDialog }}</p>
                </div>
                <hr />
                <div class="continut-roti">
                    <el-form label-position="top">
                        <el-row :gutter="15">
                            <el-col :md="24">
                                <el-form-item label="Cantitate totala">
                                    <template #label>
                                        <div style="display:flex;gap:6px;align-items:center">
                                            <span>Cantitate totala</span>
                                        </div>
                                    </template>
                                    <el-input-number :min="1" style="width:100% !important" :value="Roti.nr_roti" v-model="Roti.nr_roti" />
                                </el-form-item>
                            </el-col>
                            <el-col :sm="24">
                                <el-form-item  label="Sursa anvelopelor" style="margin-bottom: 0px !important;">
                                    <el-select style="width: 100% !important; " v-model="select_sursa_anvelopelor" clearable @change="select_sursa_anvelopelor_handler()"
                                        placeholder="Selecteaza sursa">
                                        <el-option key="dep_hotel" label="Hotel" value="dep_hotel"></el-option>
                                        <el-option key="dep_personala" label="Anvelope proprii"
                                            value="dep_personala"></el-option>
                                        <el-option key="dep_comanda" label="Comanda noua"
                                            value="dep_comanda"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="select_sursa_anvelopelor == 'dep_comanda'" class="mt-2" :sm="24" :md="24">
                                <el-form-item>
                                    <template #label>
                                        <div style="display:flex;gap:6px;align-items:center">
                                            <span>Numar comanda</span>
                                            <el-tooltip class="item" effect="dark"
                                                content="Introduceti numarul comenzii" placement="top-start">
                                                <i class="el-icon-info"></i>
                                            </el-tooltip>
                                        </div>
                                    </template>
                                    <el-tag :key="tag" v-for="tag in nrComandaTags" closable
                                        :disable-transitions="false" @close="handleClose(tag)"> {{ tag}}</el-tag>
                                    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue"
                                        ref="saveTagInput" size="mini" @keyup.enter.native="handleInputConfirm"
                                        @blur="handleInputConfirm"></el-input>
                                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+
                                        Numar
                                        comanda</el-button>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="select_sursa_anvelopelor" :sm="24" :md="24">
                                <el-form-item style="display: flex; justify-content: flex-end;align-items: center;">
                                    <template #label>
                                        &nbsp;
                                    </template>
                                    <span style="color:blue; text-decoration:underline; cursor:pointer"  @click="informatiiAditionaleHandler()"
                                        type="primary">Informatii aditionale</span>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <div class="footer-roti" style="margin-top:12px">
                        <el-button @click="salveaza_roti()">Confirma</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- dialog pentru preselectat masina -->
        <el-dialog title="" :visible.sync="arata_dialog_alege_client" width="70%" append-to-body>
            <div class="roti-container">
                <div class="titlu-roti">
                    <p>Selecteaza masina / clientul pentru programare</p>
                </div>
                <hr />
                <div class="continut-roti">
                    <h6>Cauta dupa numar inmatriculare, nume client sau telefon</h6>
                    <br />
                    <el-select size="large" placeholder="Cauta dupa numar inmatriculare, nume client sau telefon" remote
                        ref="focusShow" :remote-method="handleFindProdus" v-model="IdMasinaSelectataProgramareDirect"
                        filterable>
                        <el-option v-for="item in Info.masini" :key="'lista_masini' + item.Id" :id="'produs_cu_stoc'"
                            :name="'Client: ' + item.Nume + ' ' + item.Prenume + ' Telefon: ' + item.Telefon"
                            :label="'Auto: ' + item.Numar + (item.MarcaNume !== null && item.MarcaNume !== '' ? (' - ' + item.MarcaNume) : '') + (item.ModelNume !== null && item.ModelNume !== '' ? (' ' + item.ModelNume) : '')"
                            :value="item.Id">
                        </el-option>
                    </el-select>

                    <div v-if="!parolaCorecta">
                        <h6 style="margin-top: 22px; color: red;">
                            Introdu parola <a href="/#/seteaza_agent" style="color: red; text-decoration: underline;">aici</a> pentru a putea selecta un client existent
                        </h6>
                    </div>

                    <div class="footer-roti" style="justify-content: flex-end;">
                        <a @click="arata_dialog_alege_client = !arata_dialog_alege_client">Renunta</a>
                        <el-button size="small" v-show="this.IdMasinaSelectataProgramareDirect != ''" type="success"
                            @click="alege_clientul()">Alege</el-button>
                    </div>

                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment';

import Finalizare from './Finalizare.vue';
import settings from '../backend/LocalSettings.js';
import LocalSettings from '../backend/LocalSettings.js';

export default {

    name: "Home",
    components: {
        Finalizare
    },
    data() {
        return {
            parolaCorecta:false,
            base_url: '',
            programareTrimisa: false,
            once: false,
            Info: {
                masini: [],
            },
            arata_dialog_alege_client: false,
            IdMasinaSelectataProgramareDirect: '',
            url: window.location.hostname,
            t: 0,
            prefetch: {
                data: null,      
                promise: null,   
                targetDate: null 
            },
            NumeAgent: '',
            AgentLogat: 0,
            NoEmail: 0,
            datePickerOptions: {
                disabledDate(date) {
                    return date > new Date();
                },
            },
            programCache: {},
            cacheStartTime: null,
            cantitate_optiuni: [
                { value: '0', label: '0' },
                { value: '1', label: '1' },
                { value: '2', label: '2' },
                { value: '3', label: '3' },
                { value: '4', label: '4' },
                { value: '5', label: '5' },
                { value: '6', label: '6' },
                { value: '7', label: '7' },
                { value: '8', label: '8' },
                { value: '9', label: '9' },
                { value: '10', label: '10' },
                { value: '11', label: '11' },
                { value: '12', label: '12' },
            ],
            current_page: 0,
            loader: false,
            pages: [
                {
                    completed: false,
                    page_number: 0,
                    title: 'Programare Service',
                    description: "  ",
                    src: "page1.png"
                },
                {
                    completed: false,
                    page_number: 1,
                    title: 'Sursa si Destinatia Anvelopelor',
                    description: "",
                    src: "page2.png"
                },
                {
                    completed: false,
                    page_number: 2,
                    title: 'Alege Data si Ora22',
                    description: "",
                    src: "page2.png"
                },
                {
                    completed: false,
                    page_number: 3,
                    title: 'Lasa-ne datele tale de contact',
                    description: "",
                    src: "page3.png"
                },
            ],
            servicii: [],
            sumar: [
                /**
                 * TEMPLATE SUMAR
                 {
                    titlu: 'titlu',
                    descriere: 'descriere'
                 }
                 */
            ],
            serviciu_selectat: {
                centru: null,
                id: null,
                nume: null,
                pret: null
            },
            tip_cont: {
                client_nou: true,
                client_vechi: false,
            },
            Marci: [],
            Model_marci: [],
            Program: {},
            selectedObject: {
                data: undefined,
                data_object: undefined,
                serviciu: '',
                Data: {
                    Nume: '',
                    Prenume: '',
                    Telefon: '',
                    Email: '',
                    NoEmailTastat: '',
                    Numar: '',
                    Km: '',
                    Marca: '',
                    Model: '',
                    An: '',
                    Ora: undefined,
                    Ora_start: undefined,
                    Ora_stop: undefined,
                    Acord: Boolean(true),
                },
            },
            luna_selectata: {
                numar: '',
                nume: ''
            },
            Roti: {
                checked: false,
                show_nr_roti: false,
                hotel: false,
                nr_roti: 4,
                cantitate_depozitare_comanda: 0,
                cantitate_depozitare_hotel: 0,
                cantitate_depozitare_personala: 0,
                destinatie_reconditionare: 0,
                destinatie_hotel: 0,
                destinatie_returnare: 0,
                TitluSursa: '',
                TitluDestinatie: '',
                TextButonHotel: '',
                TextDialog: '',
            },
            nrComandaTags: [],
            inputVisible: false,
            inputValue: '',
            an_selectat: "",
            depozitare_step: 1,
            optiune_cantitati: 'fara_cantitate',
            select_sursa_anvelopelor: null,
            rules_vuetify: {
                nume: (valid) => {
                    this.selectedObject.Data.Nume = valid.toUpperCase();
                    return true;
                },
                prenume: (valid) => {
                    this.selectedObject.Data.Prenume = valid.toUpperCase();
                    return true;
                },
                required: (valid) => !!valid || "Camp obligatoriu",
                telefon: (valid) => {
                    this.selectedObject.Data.Telefon = valid.split("").filter(a => /^\d+$/.test(a)).join("");
                    // let isnum = /^\d+$/.test(valid);
                    // if (!isnum) {
                    //     return 'Numar de telefon invalid'
                    // } else {
                    //     return true;
                    // }
                    return true;
                },
                email: (valid) => {
                    this.selectedObject.Data.Email = valid.toLowerCase();
                    let email_validation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(valid);
                    if (this.AgentLogat == 1 && valid == 'noemail@anvelope.ro' && this.NoEmail == false) {
                        // this.selectedObject.Data.Email = '';
                        return "Daca clientul nu are email atunci trebuie bifata optiunea de mai jos"
                    } else if (this.AgentLogat == 1 && valid.length == 0 && this.NoEmail == false) {
                        return "Camp obligatoriu!"
                    } else if (this.AgentLogat == 1 && !email_validation) {
                        return "Format email invalid (ex: nume@gmail.com)"
                    } else if (this.AgentLogat == 0 && !email_validation && valid.length > 0) {
                        return "Format email invalid (ex: nume@gmail.com)"
                    } else {
                        return true;
                    }
                },
                noemailrule: (valid) => {

                    if (typeof valid != 'undefined') valid = valid.toLowerCase().trim();

                    let no_reply_address = valid;

                    if (no_reply_address != 'noemail@anvelope.ro') {
                        this.selectedObject.Data.Email = '';
                        return "in acest camp trebuie tastat 'noemail@anvelope.ro'"
                    } else {
                        this.selectedObject.Data.Email = 'noemail@anvelope.ro';
                        return true;
                    }
                },
                km: (valid) => {
                    this.selectedObject.Data.Km = valid.split("").filter(a => /^\d+$/.test(a)).join("");
                    return true;
                },
                numar: (valid) => {
                    this.selectedObject.Data.Numar = valid.toUpperCase();
                    if (valid.length < 3) return 'Numarul trebuie sa aiba cel putin 3 caractere';
                    let regex = /(([0-9]+[A-Z]+)|([A-Z]+[0-9]+))/
                    if (!regex.test(valid)) {
                        return 'Numarul trebuie sa aiba cel putin o litera si o cifra';
                    } else {
                        return true;
                    }
                }
            },
            rules: {
                Nume: [{ required: true, message: "Campul este obligatoriu" }],
                Prenume: [{ required: true, message: "Campul este obligatoriu" }],
                Numar: [{ required: true, message: "Campul este obligatoriu" }],
                Telefon: [{ required: true, message: "Campul este obligatoriu" }],
                Ora: [{ required: true, message: "Campul este obligatoriu" }],
            },
        }
    },
    methods: {
        get_cache_key(dateString) {
            return moment(dateString).format('YYYY-MM');
        },

        clear_cache() {
            this.programCache = {};
            this.cacheStartTime = null;
        },

        async fetch_program_data(dateString) {
            let cacheKey = this.get_cache_key(dateString);
            const CACHE_DURATION = 5 * 60 * 1000; // 5 minute
            const now = Date.now();

            if (this.cacheStartTime && (now - this.cacheStartTime > CACHE_DURATION)) {
                this.programCache = {};     
                this.cacheStartTime = null; 
            }

            if (this.programCache[cacheKey]) {
                return await this.programCache[cacheKey];
            }

            let cantitate = this.Roti.nr_roti;
            let hotel = this.Roti.hotel;
            let dateClient = {};
            if (this.AgentLogat != 1) {
                dateClient = localStorage.getItem('evio-service-account');
            }

            let args = {
                start: dateString,
                idServiciuProgramator: this.serviciu_selectat.id,
                Cantitate: cantitate,
                Hotel: hotel,
                CheckSender: settings.get_key(),
                date_client: dateClient
            };
            const url = this.base_url + '/index_php';

            let requestPromise = this.$http.post(url, args).then(response => {
                if(response && response.data) {
                    if (this.cacheStartTime === null) {
                        this.cacheStartTime = Date.now();
                    }
                }
                return response;
            }).catch(error => {
                delete this.programCache[cacheKey]; 
                throw error;
            });

            this.programCache[cacheKey] = requestPromise;

            return await requestPromise;
        },

        trigger_prefetch_next_month: function() {
            let current_date_on_screen = this.luna_selectata.numar; 
            if(!current_date_on_screen) {
                current_date_on_screen = moment().format('YYYY-MM-DD hh:mm:ss')
            };

            let next_month_date = moment(current_date_on_screen).add(1, 'M').startOf('month').format('YYYY-MM-DD hh:mm:ss');
            let cacheKey = this.get_cache_key(next_month_date);

            if (this.programCache[cacheKey]) {
                return;
            }

            this.fetch_program_data(next_month_date).then(response => {});
        },

        handleClose(tag) {
            this.nrComandaTags.splice(this.nrComandaTags.indexOf(tag), 1);
        },

        showInput() {
            this.inputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },

        handleInputConfirm() {
            let inputValue = this.inputValue && this.inputValue.trim();
            inputValue = inputValue.replace(/[^0-9]/g, '')
            if (inputValue) {
                if (this.nrComandaTags.includes(inputValue)) {
                    this.$message({
                        message: 'Numărul de comandă există deja!',
                        type: 'warning'
                    });
                } else {
                    this.nrComandaTags.push(inputValue);
                }
            }
            this.inputVisible = false;
            this.inputValue = '';
        },

        async deschide_dialog_alege_client() {
            this.arata_dialog_alege_client = true;
            this.Info.masini = [];
            this.IdMasinaSelectataProgramareDirect = '';

            await new Promise(resolve => setTimeout(resolve, 200));
            const url = this.base_url + '/checkAgentPassword';
            const parolaAgent = window.localStorage.getItem("service-evio-ParolaAgent") || '';
            let args = { CheckSender: settings.get_key(), parolaAgent: parolaAgent }
            let result = await this.$http.post(url, args);

            if (result) {
                this.parolaCorecta = result.body.success;
            }

            this.$nextTick(() => {
                this.$refs.focusShow.focus();
            });

        },
        async handleFindProdus(data) {
            if (data !== '') {
                await new Promise(resolve => setTimeout(resolve, 200));
                const url = this.base_url + '/remoteFindProdus';
                const parolaAgent = window.localStorage.getItem("service-evio-ParolaAgent") || '';
                let args = { CheckSender: settings.get_key(), string: data, parolaAgent: parolaAgent }
                let result = await this.$http.post(url, args);

                if (result) {
                    this.Info.masini = result.body.masini;
                }
            }
        },

        bifa_no_email: function () {
            if (!this.NoEmail) {
                this.selectedObject.Data.Email = '';
            }
        },

        select_sursa_anvelopelor_handler: function () {
            switch (this.select_sursa_anvelopelor) {
                case 'dep_hotel':
                    this.Roti.cantitate_depozitare_hotel = this.Roti.nr_roti;
                    this.Roti.cantitate_depozitare_comanda = 0;
                    this.Roti.cantitate_depozitare_personala = 0;
                    this.Roti.hotel = true;
                    break;
                case 'dep_personala':
                    this.Roti.cantitate_depozitare_personala = this.Roti.nr_roti;
                    this.Roti.cantitate_depozitare_comanda = 0;
                    this.Roti.cantitate_depozitare_hotel = 0;
                    this.Roti.hotel = false;
                    break;
                case 'dep_comanda':
                    this.Roti.cantitate_depozitare_comanda = this.Roti.nr_roti;
                    this.Roti.cantitate_depozitare_hotel = 0;
                    this.Roti.cantitate_depozitare_personala = 0;
                    this.Roti.hotel = false;
                    break;
                default:
                    this.Roti.cantitate_depozitare_comanda = 0;
                    this.Roti.cantitate_depozitare_hotel = 0;
                    this.Roti.cantitate_depozitare_personala = 0;
                    this.Roti.hotel = false;
                    break;
            }
        },

        format_numar: function () {
            this.selectedObject.Data.Numar = this.selectedObject.Data.Numar.replaceAll(' ', '');
            this.selectedObject.Data.Numar = this.selectedObject.Data.Numar.toUpperCase();
        },

        reload: function () {
            this.$router.go(0);
        },

        alege_serviciu: async function (serviciu) {
            this.clear_cache();
            // console.log(serviciu);
            this.serviciu_selectat = {
                centru: serviciu.IdCentruProductie,
                id: serviciu.Id,
                nume: serviciu.Nume,
                // pret: serviciu.Pret
            };
            this.sumar[0] = {
                titlu: 'SERVICIU',
                descriere: serviciu.Nume
            }
            this.optiune_cantitati = serviciu.OptiuneCantitati;
            this.select_sursa_anvelopelor = null;
            switch (this.optiune_cantitati) {
                case 'fara_cantitate':
                    this.Roti.nr_roti = 1;
                    this.salveaza_roti();
                    break;
                case 'cantitate_bifa_hotel':
                    this.Roti.TextDialog = (serviciu.TextDialog && serviciu.TextDialog != '') ? serviciu.TextDialog : ''
                    this.Roti.TextButonHotel = (serviciu.TextButonHotel && serviciu.TextButonHotel != '') ? serviciu.TextButonHotel : '';
                    this.depozitare_step = 1;
                    this.Roti.show_nr_roti = true;
                    this.Roti.nr_roti = 4;
                    break;
                case 'sursa_destinatie':
                    this.Roti.TextDialog = (serviciu.TextDialog && serviciu.TextDialog != '') ? serviciu.TextDialog : ''
                    this.Roti.TitluSursa = (serviciu.TitluSursa && serviciu.TitluSursa != '') ? serviciu.TitluSursa : '';
                    this.Roti.TitluDestinatie = (serviciu.TitluDestinatie && serviciu.TitluDestinatie != '') ? serviciu.TitluDestinatie : '';
                    this.Roti.LabelSursaHotel = (serviciu.LabelSursaHotel && serviciu.LabelSursaHotel != '') ? serviciu.LabelSursaHotel : '';
                    this.Roti.LabelSursaComanda = (serviciu.LabelSursaComanda && serviciu.LabelSursaComanda != '') ? serviciu.LabelSursaComanda : '';
                    this.Roti.LabelSursaPersonal = (serviciu.LabelSursaPersonal && serviciu.LabelSursaPersonal != '') ? serviciu.LabelSursaPersonal : '';
                    this.Roti.LabelDestinatieReciclare = (serviciu.LabelDestinatieReciclare && serviciu.LabelDestinatieReciclare != '') ? serviciu.LabelDestinatieReciclare : '';
                    this.Roti.LabelDestinatieHotel = (serviciu.LabelDestinatieHotel && serviciu.LabelDestinatieHotel != '') ? serviciu.LabelDestinatieHotel : '';
                    this.Roti.LabelDestinatieReturnare = (serviciu.LabelDestinatieReturnare && serviciu.LabelDestinatieReturnare != '') ? serviciu.LabelDestinatieReturnare : '';
                    this.Roti.nr_roti = 4;
                    this.Roti.show_nr_roti = true;
                    this.depozitare_step = 1;
                    break;

            }
            this.Roti.cantitate_depozitare_comanda = 0;
            this.Roti.cantitate_depozitare_hotel = 0;
            this.Roti.cantitate_depozitare_personala = 0;
            this.Roti.destinatie_reconditionare = 0;
            this.Roti.destinatie_hotel = 0;
            this.Roti.destinatie_returnare = 0;


            this.nrComandaTags = [];
            this.inputVisible = false;
        },

        validare_cantitati() {
            // console.log('validare cantitati', this.Roti);
            if (this.optiune_cantitati == 'sursa_destinatie' && parseInt(this.Roti.cantitate_depozitare_hotel) + parseInt(this.Roti.cantitate_depozitare_comanda) + parseInt(this.Roti.cantitate_depozitare_personala) != this.Roti.nr_roti) {
                this.$message.error('Cantitatea de roti depozitata in hotel impreuna cu cea personala si cea de comanda trebuie sa fie egala cu cantitatea totala de roti!');
                return false;
            }
            if (this.optiune_cantitati == 'sursa_destinatie' && this.Roti.cantitate_depozitare_hotel == 0) {
                this.Roti.hotel = false
            } else if (this.optiune_cantitati == 'sursa_destinatie' && this.Roti.cantitate_depozitare_hotel != 0) {
                this.Roti.hotel = true
            }

            return true;
        },

        schimba_tip_client: async function (type) {
            if (type == 0 && this.tip_cont.client_nou) return;
            if (type == 1 && this.tip_cont.client_vechi) return;
            this.loader = true;
            this.tip_cont.client_nou = !this.tip_cont.client_nou;
            this.tip_cont.client_vechi = !this.tip_cont.client_vechi;
            if (this.tip_cont.client_vechi) {
                if (localStorage.getItem('evio-service-account')) {
                    let data = JSON.parse(localStorage.getItem('evio-service-account'));
                    this.selectedObject.Data.Nume = data.Nume;
                    this.selectedObject.Data.Prenume = data.Prenume;
                    this.selectedObject.Data.Telefon = data.Telefon;
                    this.selectedObject.Data.Email = data.Email;
                    this.selectedObject.Data.An = data.An;
                    this.selectedObject.Data.Km = data.Km;
                    this.selectedObject.Data.Numar = data.Numar;

                    await this.load_model_marca(data.Marca['Id']);

                    this.selectedObject.Data.Marca = data.Marca;
                    this.selectedObject.Data.Model = data.Model;
                    
                }
            } else {
                this.selectedObject.Data.Nume = '';
                this.selectedObject.Data.Prenume = '';
                this.selectedObject.Data.Telefon = '';
                this.selectedObject.Data.Email = '';
                this.selectedObject.Data.Marca = '';
                this.selectedObject.Data.Model = '';
                this.selectedObject.Data.Numar = '';
                this.selectedObject.Data.An = '';
                this.selectedObject.Data.Km = '';

            }
            this.loader = false;
        },

        alege_clientul: async function (type) {

            this.arata_dialog_alege_client = false;
            this.loader = true;

            let date_auto = this.Info.masini.filter((value) => value.Id == this.IdMasinaSelectataProgramareDirect)[0];

            this.selectedObject.Data.Nume = date_auto.Nume;
            this.selectedObject.Data.Prenume = date_auto.Prenume;
            this.selectedObject.Data.Telefon = date_auto.Telefon;
            this.selectedObject.Data.Email = date_auto.Email;
            this.selectedObject.Data.An = date_auto.An;
            this.selectedObject.Data.Numar = date_auto.Numar;
            await this.load_model_marca(date_auto.Marca);

            // console.log('Am selectat masina', date_auto);

            this.selectedObject.Data.Marca = date_auto.Marca;
            this.selectedObject.Data.Model = date_auto.Model;


            // if (typeof date_auto.Marca == 'string') {
            //     this.selectedObject.Data.ObiectMarca = this.Marci.filter((value) => value.Nume == date_auto.Marca.toUpperCase())[0];

            //     if (typeof this.selectedObject.Data.ObiectMarca !== 'undefined' && this.selectedObject.Data.ObiectMarca.Id > 0) {
            //         this.selectedObject.Data.Marca = this.selectedObject.Data.ObiectMarca.Id;
            //         await this.load_model_marca(this.selectedObject.Data.ObiectMarca);
            //         if (typeof date_auto.Model == 'string') {
            //             this.selectedObject.Data.ObiectModel = this.Model_marci.filter((value) => value.Nume == date_auto.Model.toUpperCase())[0];
            //             if (typeof this.selectedObject.Data.ObiectModel.Nume == 'string' && this.selectedObject.Data.ObiectModel.Id > 0) {
            //                 this.selectedObject.Data.Model = this.selectedObject.Data.ObiectModel.Id;
            //             } else {
            //                 this.selectedObject.Data.Model = "";
            //             }
            //         }

            //     } else {
            //         this.selectedObject.Data.IdMarca = "";
            //     }
            // }

            this.loader = false;

        },

        load_marci: async function () {
            const url = this.base_url + '/get_marci';
            let args = { CheckSender: settings.get_key() }
            let response = await this.$http.post(url, args);
            let most_used = [
                "audi",
                "bmw",
                "dacia",
                "ford",
                "renault",
                "mercedes-benz",
                "opel",
                "skoda",
                "volkswagen"
            ]

            var most_used_list = [];
            var others = [];

            response.body.raspuns.map(r => {
                return {
                    Id: r.Id,
                    Nume: r.Nume.toUpperCase()
                }
            }).forEach(marca => {
                if (most_used.includes(marca.Nume.toLowerCase())) {
                    // console.log('Am gasit', marca.Nume);
                    most_used_list.push(marca);
                } else {
                    others.push(marca);
                }
            });

            this.Marci = [{ header: "Marci populare" }, ...most_used_list, { divider: true }, ...others];
            // console.log(this.Marci)

        },



        load_model_marca: async function (Marca) {
            this.selectedObject.Data.Model = "";
            const url = this.base_url + '/get_tipuri_marca';
            let args = { IdMarca: Marca, CheckSender: settings.get_key() }
            let response = await this.$http.post(url, args);
            this.Model_marci = response.body.raspuns.map(r => {
                return {
                    Id: r.Id,
                    Nume: r.Nume.toUpperCase(),
                    IdMarca: r.IdMarca
                }
            });
            // console.log(this.Model_marci);
        },


        save: async function () {

            let valid = this.$refs["my-form"].validate()
            if (valid) {
                this.programareTrimisa = true;
                this.once = true;
                if (localStorage.getItem('evio-service-account')) {
                    localStorage.removeItem('evio-service-account');
                    localStorage.setItem('evio-service-account', JSON.stringify(this.selectedObject.Data));
                } else {
                    localStorage.setItem('evio-service-account', JSON.stringify(this.selectedObject.Data));
                }
                const cantitateRoti = {
                    CantDepozitareHotel: this.Roti.cantitate_depozitare_hotel,
                    CantDepozitarePersonala: this.Roti.cantitate_depozitare_personala,
                    CantDepozitareComanda: this.Roti.cantitate_depozitare_comanda,
                }

                const destinatieRoti = {
                    Reconditionare: this.Roti.destinatie_reconditionare,
                    Hotel: this.Roti.destinatie_hotel,
                    Returnare: this.Roti.destinatie_returnare,
                }

                this.selectedObject.Data.sursa_anvelopelor = this.select_sursa_anvelopelor;

                let args = { data: this.selectedObject.Data, idServiciuProgramator: this.serviciu_selectat.id, CheckSender: settings.get_key(), Sursa: settings.get_local_url(), cantitateRoti: cantitateRoti, destinatieRoti: destinatieRoti, numarComanda: this.nrComandaTags }
                const api_url = this.base_url + '/adauga_programare';
                const temp_marca = this.selectedObject.Data.Marca;
                const temp_model = this.selectedObject.Data.Model;

                this.selectedObject.Data.NumeAgent = this.NumeAgent;
                // daca exista this.selectedObject.Data.Marca.Id
                if (this.selectedObject?.Data?.Marca?.Id != null) {
                    this.selectedObject.Data.Marca = this.selectedObject.Data.Marca.Id || "";
                }
                // la fel la Model
                if (this.selectedObject?.Data?.Model?.Id != null) {
                    this.selectedObject.Data.Model = this.selectedObject.Data.Model.Id || "";
                }
                // console.log(this.selectedObject.Data)
                this.selectedObject.Data.Cantitate = this.Roti.nr_roti;
                this.selectedObject.Data.Hotel = this.Roti.hotel;

                let res = await this.$http.post(api_url, args);
                this.once = false;
                this.selectedObject.Data.Marca = temp_marca;
                this.selectedObject.Data.Model = temp_model;

                if (res.body.success == true && res.body.sms_sent) {
                    let idProgramare = res.body.IdProgramare;
                    this.$refs.finalizare.show_me(this.serviciu_selectat, this.selectedObject.Data, idProgramare);
                    await this.$message({
                        type: "success",
                        message: "Programare efectuata cu succes",
                    });
                }else if(res.body.success && !res.body.sms_sent) {
                    if(localStorage.getItem('service-evio-ParolaAgent')){
                        this.$message({
                            type: "warning",
                            message: "Programarea a fost realizata cu succes, dar SMS-ul nu a fost trimis catre client (" + res.body.sms_error + ')',
                            duration: 8000
                        })

                        this.$refs.finalizare.show_me(this.serviciu_selectat, this.selectedObject.Data, idProgramare);
                    }else{
                        this.$message({
                            type: "warning",
                            message: "Programarea a fost realizata cu succes, dar am intampinat probleme la trimiterea SMS-ului de confirmare. Pentru mai multe detalii, sunati la: 0754004400",
                            duration: 8000
                        })

                    }
                    let idProgramare = res.body.IdProgramare;
                    this.$refs.finalizare.show_me(this.serviciu_selectat, this.selectedObject.Data, idProgramare);
                }else if(!res.body.success){
                    this.$message({
                        type: "warning",
                        message: "Programarea nu a putut fi efectuata. (" + res.body.error + ')',
                    });
                    this.programareTrimisa = false;
                    this.schimba_tip_client(0);
                    if (typeof res.refresh) {
                        this.load_program(this.serviciu_selectat.id);
                    }
                        this.previous_page();
                }

                this.clear_cache();

            }
        },

        select_date: async function (value) {
            if (value[1].count_intervale_libere == 0) return;
            if (value[1].count_intervale_libere == value[1].count_intervale_ocupate && value[1].count_intervale_libere == 0) return;
            let cantitate = this.Roti.nr_roti;
            let hotel = this.Roti.hotel
            const api_url = this.base_url + '/index_zi_php';
            let args = { zi: value[0], idServiciuProgramator: this.serviciu_selectat.id, Cantitate: cantitate, Hotel: hotel, CheckSender: settings.get_key() }
            let response = await this.$http.post(api_url, args);
            this.selectedObject.data = `${this.get_day(value[0])} ${this.get_nume_luna(moment(value[0]).format('MM'))}`;
            this.selectedObject.data_object = response.data;
            this.sumar[1] = {
                titlu: 'DATA',
                descriere: this.selectedObject.data
            };
            setTimeout(() => {
                document.getElementById('ore').scrollIntoView();
            }, 10)
        },

        select_hour: function (value) {
            if (!value.liber) return;
            this.selectedObject.Data.Ora = value.start;
            this.selectedObject.Data.Ora_start = value.start;
            this.selectedObject.Data.Ora_stop = value.stop;
            this.sumar[2] = {
                titlu: 'ORA',
                descriere: moment(value.start).format('HH:mm'),
            }
            this.selectedObject.Data.Acord = true;
            this.next_page();
        },

        next_page: async function () {
            // if (this.current_page == 0 && (this.optiune_cantitati != 'sursa_destinatie' || ((this.optiune_cantitati == 'sursa_destinatie') && !this.select_sursa_anvelopelor))) {
            if (this.current_page == 0) {
                this.pages[this.current_page].completed = true;
                this.current_page += 2;
            } else {
                if (this.current_page == 1) {
                    const validation = this.validare_cantitati();
                    if (!validation) {
                        return;
                    }
                    this.load_program(this.serviciu_selectat.id);
                }
                this.pages[this.current_page].completed = true;
                this.current_page++;
            }

        },

        overrideStep() {
            this.Roti.cantitate_depozitare_hotel = 0;
            this.Roti.hotel = false;

            this.Roti.cantitate_depozitare_personala = 0;
            this.Roti.cantitate_depozitare_comanda = 0;

            this.Roti.destinatie_reconditionare = 0;
            this.Roti.destinatie_hotel = 0;
            this.Roti.destinatie_returnare = 0;

            this.load_program(this.serviciu_selectat.id);
            this.pages[this.current_page].completed = true;
            this.current_page++;
        },

        previous_page: async function () {
            if(this.current_page == 0) {
                this.Roti.hotel = false;
            }
            if (this.current_page == 2) {
                this.current_page -= 2;
            } else {
                this.current_page--;
                this.pages[this.current_page].completed = false;
            }
        },

        goToFirstPage() {
            for (let index = 0; index <= 2; index++) {
                this.pages[index].completed = false;
            }

            this.tip_cont = {
                client_nou: true,
                client_vechi: false,
            },

                this.selectedObject = {
                    data: undefined,
                    data_object: undefined,
                    serviciu: '',
                    Data: {
                        Nume: '',
                        Prenume: '',
                        Telefon: '',
                        Email: '',
                        NoEmailTastat: '',
                        Numar: '',
                        Km: '',
                        Marca: '',
                        Model: '',
                        An: '',
                        Ora: undefined,
                        Ora_start: undefined,
                        Ora_stop: undefined,
                        Acord: Boolean(true),
                    },
                },

                this.programareTrimisa = false;
            this.once = false;

            this.current_page = 0;
        },

        getImgUrl(page) {
            return require("../assets/" + page)
        },

        get_day: function (date) {
            let day = moment(date).format('D');
            return day;
        },

        clear_program: function () {
            this.Program = {};
        },

        previous_month: async function() {
            if (this.loader) return;

            this.loader = true;
            let previous_month = moment(this.luna_selectata.numar).add(-1, 'M').startOf('month').format('YYYY-MM-DD hh:mm:ss');
            
            let response = await this.fetch_program_data(previous_month);

            this.clear_program();
            this.Program = Object.entries(response.data.zile);
            
            this.luna_selectata.numar = previous_month;
            this.luna_selectata.nume = this.get_nume_luna(moment(previous_month).format('MM'));
            this.an_selectat = moment(previous_month).format('YYYY');
            
            this.loader = false;
        },

        next_month: async function() {
            if (this.loader) return;

            this.loader = true;
            let target_date = moment(this.luna_selectata.numar).add(1, 'M').startOf('month').format('YYYY-MM-DD hh:mm:ss');

            let response = await this.fetch_program_data(target_date);

            this.clear_program();
            this.Program = Object.entries(response.data.zile);
            
            this.luna_selectata.numar = target_date;
            this.luna_selectata.nume = this.get_nume_luna(moment(target_date).format('MM'));
            this.an_selectat = moment(target_date).format('YYYY');
            
            this.loader = false;
            this.trigger_prefetch_next_month();
        },

        get_nume_luna: function (luna) {
            var nume = '';
            switch (luna) {
                case "01":
                    nume = "Ianuarie";
                    break;

                case "02":
                    nume = "Februarie";
                    break;

                case "03":
                    nume = "Martie";
                    break;

                case "04":
                    nume = "Aprilie";
                    break;

                case "05":
                    nume = "Mai";
                    break;

                case "06":
                    nume = "Iunie";
                    break;

                case "07":
                    nume = "Iulie";
                    break;

                case "08":
                    nume = "August";
                    break;

                case "09":
                    nume = "Septembrie";
                    break;

                case "10":
                    nume = "Octombrie";
                    break;

                case "11":
                    nume = "Noiembrie";
                    break;

                case "12":
                    nume = "Decembrie";
                    break;
            }
            return nume;
        },

        salveaza_roti() {
            this.clear_cache();
            
            this.prefetch = { data: null, promise: null, targetDate: null };

            this.Roti.show_nr_roti = false;
            this.Roti.checked = true;
            this.load_program(this.serviciu_selectat.id);
            this.next_page();
        },


        load_program: async function (id) {
            this.loader = true;
            this.selectedObject = {
                data: undefined,
                data_object: undefined,
                serviciu: '',
                Data: {
                    Nume: '',
                    Prenume: '',
                    Telefon: '',
                    Email: '',
                    Km: '',
                    Numar: '',
                    Marca: '',
                    Model: '',
                    An: '',
                    Ora: undefined
                }
            }
            let start_of_month = moment().startOf('month').format('YYYY-MM-DD hh:mm:ss');

            let response = await this.fetch_program_data(start_of_month);
            
            this.Program = Object.entries(response.data.zile);

            this.luna_selectata.numar = start_of_month;
            this.luna_selectata.nume = this.get_nume_luna(moment(start_of_month).format('MM'));
            this.an_selectat = moment(start_of_month).format('YYYY');
            // console.log(this.Program);
            this.loader = false;

            this.trigger_prefetch_next_month();
        },

        load_servicii: async function () {
            const url = this.base_url + '/get_centre_productie';
            let args = { CheckSender: settings.get_key() }
            let response = await this.$http.post(url, args);
            this.pages[0].title = response.body.Setari.TitleProgramator1;
            this.pages[1].title = response.body.Setari.TitleProgramator2;
            this.pages[2].title = response.body.Setari.TitleProgramator3;
            this.pages[3].title = response.body.Setari.TitleProgramator4;


            this.pages[0].description = response.body.Setari.SubtitleProgramator1;
            this.pages[1].description = response.body.Setari.SubtitleProgramator2;
            this.pages[2].description = response.body.Setari.SubtitleProgramator3;
            this.pages[3].description = response.body.Setari.SubtitleProgramator4;

            let servicii = response.body.raspuns;
            // console.log(servicii);
            // console.log(servicii);
            servicii.forEach(serviciu => {
                let data = serviciu;
                this.servicii.push(data);
            });
        },

        informatiiAditionaleHandler() {
            this.current_page = 1;
            this.Roti.show_nr_roti = !this.Roti.show_nr_roti
            this.Roti.cantitate_depozitare_personala = 0;
            switch (this.select_sursa_anvelopelor) {
                case 'dep_hotel':
                    this.Roti.cantitate_depozitare_hotel = this.Roti.nr_roti;
                    break;
                case 'dep_comanda':
                    this.Roti.cantitate_depozitare_comanda = this.Roti.nr_roti;
                    break;
                case 'dep_personala':
                    this.Roti.cantitate_depozitare_personala = this.Roti.nr_roti;
                    break;
            }
        },
    },

    mounted() {
        this.base_url = LocalSettings.BASE_URL + '/test_api';

        this.load_servicii();
        this.load_marci();

        if (settings.get_numeAgent() != null) {
            // console.log('e logat')
            // console.log(typeof settings.get_numeAgent())
            // console.log(settings.get_numeAgent())
            this.NumeAgent = settings.get_numeAgent();
            this.AgentLogat = 1;
        }
    },
}
</script>

<style lang="less">
@gri: #F1F2F2;
@gri_inchis: #8e97b3;
@albastru_transparent: rgba(76, 100, 232, 0.445);
@albastru: #4C63E8;
@verde: #4C63E8;
@rosu-hover: #F7E8E8;
@rosu: #ec7376;
@rosu_deschis: #F7E8E8;
@galben: #FEF6CB;
@galben_wallpaper: #FCFEF1;
@galben_inchis: #E1D588;
@galben_override: #a08d0c;
@liber: #caffc4;
@liber_text: #185210;
@ocupat: #f3f5f9;
@ocupat_text: #b3bbca;
@zi_indisponibila: #f7e9e9;
@zi_indisponibila_text: #752f2f;


#produs_cu_stoc:after {
    content: attr(name);
    width: auto;
    max-height: 27px !important;
    color: rgb(0, 0, 0);
    display: flex;
    justify-content: center;
    align-items: center;
    float: right;
    font-size: 12px !important;
    padding: 0 5px;
    margin: 2px 0;
    border: 1px solid transparent;
    border-radius: 7px;
    background-color: #d6dee5a1;
}


.el-tag+.el-tag {
    margin-left: 10px;
}

.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}



.v-input--selection-controls {
    margin-top: -12px !important;
    margin-bottom: 11px !important;
    padding-top: 0px !important;
}

.el-dialog__wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;

}

.el-dialog {
    margin-top: 0 !important;
}


.roti-container {
    width: 100%;
    height: 100%;

    .titlu-roti {
        width: 100%;
        // border: 1px solid red;
        height: 50px;
        display: flex;
        padding: 20px;
        padding-bottom: 0;
        justify-content: flex-start;
        align-items: center;
        font-size: 14px;
        margin: 0;
        font-weight: 700;

        p {
            color: @albastru;
            padding: 0;
            margin: 0;
        }
    }

    .continut-roti {
        width: 100%;
        // height: 100%;
        padding: 10px 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;

        .el-form {
            display: flex;
            justify-content: space-evenly;
            // align-items: center;
            flex-direction: column;
        }

        .footer-roti {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .el-button {
                margin: 20px 0 0;
                background-color: @albastru;
                color: white;
            }

            a {
                color: @albastru;
                font-weight: 600;
                margin: 20px 15px 0 0;
                padding: 0;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .continut-roti-scrollable {
        width: 100%;
        // height: 100%;
        padding: 10px 20px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        max-height: 500px;

        @media(max-width: 1920px) {
            max-height: 380px;
            overflow-y: auto;
        }

        @media(max-width: 1440px) {
            max-height: 470px;
            overflow-y: auto;
        }

        @media(max-width: 1024px) {
            max-height: 250px;
            overflow-y: auto;
        }

        @media(max-width: 780px) {
            max-height: auto;
            overflow-y: auto;

            .el-form-item{
                margin: 0px !important;
            }

            .el-form-item__label{
                padding: 0px !important;
            }
        }

        .el-form {
            display: flex;
            justify-content: space-evenly;
            // align-items: center;
            flex-direction: column;
        }

        .footer-roti {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .el-button {
                margin: 20px 0 0;
                background-color: @albastru;
                color: white;
            }

            a {
                color: @albastru;
                font-weight: 600;
                margin: 20px 15px 0 0;
                padding: 0;
                text-align: center;
                cursor: pointer;
            }
        }
    }

}

.error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
}

.v-application .error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
}



.rezervari {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}


.content {
    width: 60%;
    height: 63%;
    display: flex;
    align-items: center;
    flex-direction: row;
    border-radius: 5px;
    box-shadow: 0px 2px 4px #00000033, 0px 20px 50px #00000066;
}




.left-content,
.right-content,
.center-content {
    height: 100%;
}

.left-content {
    background-color: #fff;
    width: 22%;

    .header {
        width: 100%;
        height: 10%;
        display: flex;
        justify-content: center;
        align-items: center;

        .steps-active,
        .steps-inactive {
            margin: 0 0.5rem;
        }

        .steps-active {
            width: 10px;
            height: 10px;
            background-color: @albastru;
            border-radius: 2px;
        }

        .steps-inactive {
            width: 10px;
            height: 10px;
            background-color: @gri;
            border-radius: 2px;
        }
    }

    .main {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 70%;
        flex-direction: column;
        font-weight: 800;
        animation: fadeIn 1s;

        h1 {
            font-size: 18px;
            text-align: center;
            color: @albastru;
        }

        h3 {
            font-size: 14px;
            color: @gri_inchis;
        }
    }

    .footer {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 20%;
        flex-direction: column;
        font-weight: 800;

        h1 {
            font-size: 14px;
            color: @albastru;
        }

        h3 {
            font-size: 12px;
            color: @gri_inchis;
        }
    }
}

.center-content {
    border: 1px solid @gri;
    border-top: none;
    border-bottom: none;
    width: 50%;
    animation: fadeIn 1s;

    .header {
        width: 90%;
        height: 8%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: flex-start;

        h1 {
            font-size: 18px;
            color: @albastru;
            margin-bottom: 0;
        }
    }

    .main {
        width: 100%;
        height: 80%;
        border-top: 1px solid @gri;
        border-bottom: 1px solid @gri;
        display: flex;
        overflow: auto;
        align-items: center;
        flex-direction: column;



        .select-container {

            border: 2px solid #E5E7EE !important;
            border-radius: 5px;
            width: 90%;
            margin: 20px 0;
            height: 130px;
            cursor: pointer;
            box-shadow: none;
            transition: all .3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            animation: FromTop 0.45s;

            .img-div {
                width: 100px;
                height: 100px;
                margin: 10px;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    max-width: 100%;
                    max-height: 100%;
                }
            }

            .serviciu {
                transition: 0.4s;
                width: 80%;
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                flex-direction: column;
                text-align: start;
                padding: 0 10px;

                h1 {
                    font-size: 18px;
                    color: @albastru
                }

                h4 {
                    font-size: 14px;
                }
            }

            .pret {
                width: 30%;
                height: 85%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                border-left: 1px solid @gri;
                padding: 0 10px;
                text-align: center;

                h1 {
                    color: @albastru;
                    font-size: 20px;
                }

                h4 {
                    color: @gri_inchis;
                    font-size: 14px;
                }
            }

        }

        .select-container:hover {
            border: 2px solid #4c63e8 !important;

            .serviciu {
                margin-left: 10px;
            }

        }

        .select-container-active {
            border: 3px solid @albastru !important;
            box-shadow: 5px 10px 0 @albastru_transparent;

        }


    }

    .footer {
        width: 100%;
        height: 12%;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .el-button {
            margin: 0 20px;
            background-color: @albastru;
            color: white;
        }
    }

    .footer-ora {
        margin: 0 10px;
        width: 100%;
        height: 5%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .content-footer {
            height: 100%;
            width: 95%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0;

            a {
                color: @albastru;
                font-weight: 600;
                margin: 0;
                padding: 0;
                text-align: center;
                cursor: pointer;
            }

            span {
                color: @galben_override;
                font-weight: 600;
                margin: 0;
                padding: 0;
                text-align: center;
                cursor: pointer;
            }
        }
    }

    .main-ora {
        box-sizing: border-box;
        width: 100%;
        height: 87%;
        overflow: auto;
        border-top: 1px solid @gri;
        border-bottom: 1px solid @gri;
        display: flex;
        align-items: center;
        flex-direction: column;
        scroll-behavior: smooth !important;

        .nav {
            width: 90%;
            height: 60px;
            margin: 20px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            p {
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 0;

                span {
                    color: @gri_inchis;
                }
            }

            .el-button {
                border: none;
                font-weight: 800;
            }
        }

        .container-program {
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 0;
            padding: 0;
            width: 100%;
        }


        .ore {
            box-sizing: border-box;
            margin: 3% 0;
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 16px;
                width: 100%;
                text-align: center;
                border-bottom: 1px solid @gri;
                // line-height: 0.1em;
                margin: 10px 0 20px;
            }

            p .bara {
                background: #fff;
                padding: 0 10px;
            }

            p .data {
                color: @albastru;
                font-weight: 600;
            }

            .butoane {
                font-size: 14px;
                margin: 0 44px;
                max-width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .liber {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: @liber;
                    color: @liber_text;
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                }

                .ocupat {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: @ocupat;
                    color: @ocupat_text;
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                    cursor: not-allowed;
                }

                .liber:hover {
                    border: 1px solid #6bd25b;
                    cursor: pointer;
                }

                .button-ora {
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                }
            }
        }

        .program {
            animation: ToTopOrar 0.45s;
            margin: 0 auto;
            padding: 0;
            width: 100% !important;
            box-sizing: border-box;
            display: grid;
            justify-content: center;
            grid-template-columns: repeat(7, 12.5%);
            grid-column-gap: 0px;
            grid-row-gap: 0px;

            .header {
                margin: 0;
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: @albastru;
                font-size: 14px;
                font-weight: 700;
            }

            .header-weekend {
                color: @galben_inchis;
                background-color: @galben_wallpaper;
            }

            .zi {
                margin: 0;
                width: 100%;
                height: 65px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0;
                font-size: 14px;

                .button-zi-disponibila {
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @gri;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    transition: 0.1s;

                    .bara-liber {
                        overflow: hidden;
                        width: 75%;
                        height: 6px;
                        border-radius: 3px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        flex-direction: row;
                        background-color: #e6e9ef;

                        .liber {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: #8fe286;
                        }

                        .ocupat {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: transparent;
                        }
                    }
                }


                .button-zi-disponibila:hover {
                    font-size: 18px;
                }

                .button-zi-disponibila_nu_in_luna_curenta {
                    opacity: 0.5;
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: #efefefbb;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    transition: 0.1s;

                    .bara-liber {
                        overflow: hidden;
                        width: 75%;
                        height: 6px;
                        border-radius: 3px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        flex-direction: row;
                        background-color: #e6e9ef;

                        .liber {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: #8fe286;
                        }

                        .ocupat {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: transparent;
                        }
                    }
                }


                .button-zi-disponibila_nu_in_luna_curenta:hover {
                    font-size: 18px;
                    opacity: 1;
                }

                .button-zi-indisponibila {
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @zi_indisponibila;
                    color: @zi_indisponibila_text;
                    cursor: not-allowed;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    opacity: 0.5;
                }

                .button-zi-plina {
                    margin: 0;
                    width: 55px;
                    height: 55px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @zi_indisponibila;
                    color: @zi_indisponibila_text;
                    cursor: not-allowed;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                }
            }

        }


        .weeks {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 0;
            padding: 10px 0;

            .el-button {
                margin: 10px 0;
                width: 50px;
                height: 50px;
                text-align: center;
                padding: 0;

                span {
                    font-weight: 800 !important;
                }

            }
        }
    }

    .main-sursa-destinatie {
        box-sizing: border-box;
        width: 100%;
        height: 87%;
        overflow: auto;
        border-top: 1px solid @gri;
        border-bottom: 1px solid @gri;
        display: flex;
        align-items: center;
        scroll-behavior: smooth !important;

        @media (max-width: 1024px) {
            flex-direction: column;
            align-items: stretch;
        }

        .nav {
            width: 90%;
            height: 60px;
            margin: 20px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            p {
                font-size: 18px;
                font-weight: 600;
                margin-bottom: 0;

                span {
                    color: @gri_inchis;
                }
            }

            .el-button {
                border: none;
                font-weight: 800;
            }
        }

        .container-program {
            display: flex;
            justify-content: center;
            flex-direction: column;
            margin: 0;
            padding: 0;
            width: 100%;
        }


        .ore {
            box-sizing: border-box;
            margin: 3% 0;
            width: 100%;
            text-align: center;
            display: flex;
            justify-content: center;
            flex-direction: column;

            p {
                font-size: 16px;
                width: 100%;
                text-align: center;
                border-bottom: 1px solid @gri;
                // line-height: 0.1em;
                margin: 10px 0 20px;
            }

            p .bara {
                background: #fff;
                padding: 0 10px;
            }

            p .data {
                color: @albastru;
                font-weight: 600;
            }

            .butoane {
                font-size: 14px;
                margin: 0 44px;
                max-width: 100%;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .liber {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: @liber;
                    color: @liber_text;
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                }

                .ocupat {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    background-color: @ocupat;
                    color: @ocupat_text;
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                    cursor: not-allowed;
                }

                .liber:hover {
                    border: 1px solid #6bd25b;
                    cursor: pointer;
                }

                .button-ora {
                    margin: 3px;
                    padding: 8px 3px;
                    width: 83px;
                    height: 31px;
                    border-radius: 5px;
                }
            }
        }

        .program {
            animation: ToTopOrar 0.45s;
            margin: 0 auto;
            padding: 0;
            width: 100% !important;
            box-sizing: border-box;
            display: grid;
            justify-content: center;
            grid-template-columns: repeat(7, 12.5%);
            grid-column-gap: 0px;
            grid-row-gap: 0px;

            .header {
                margin: 0;
                width: 100%;
                height: 40px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: @albastru;
                font-size: 14px;
                font-weight: 700;
            }

            .header-weekend {
                color: @galben_inchis;
                background-color: @galben_wallpaper;
            }

            .zi {
                margin: 0;
                width: 100%;
                height: 65px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 0;
                font-size: 14px;

                .button-zi-disponibila {
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @gri;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    transition: 0.1s;

                    .bara-liber {
                        overflow: hidden;
                        width: 75%;
                        height: 6px;
                        border-radius: 3px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        flex-direction: row;
                        background-color: #e6e9ef;

                        .liber {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: #8fe286;
                        }

                        .ocupat {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: transparent;
                        }
                    }
                }


                .button-zi-disponibila:hover {
                    font-size: 18px;
                }

                .button-zi-disponibila_nu_in_luna_curenta {
                    opacity: 0.5;
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: #efefefbb;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    transition: 0.1s;

                    .bara-liber {
                        overflow: hidden;
                        width: 75%;
                        height: 6px;
                        border-radius: 3px;
                        display: flex;
                        justify-content: flex-start;
                        align-items: center;
                        flex-direction: row;
                        background-color: #e6e9ef;

                        .liber {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: #8fe286;
                        }

                        .ocupat {
                            width: 100%;
                            height: 100%;
                            margin: 0;
                            padding: 0;
                            background-color: transparent;
                        }
                    }
                }


                .button-zi-disponibila_nu_in_luna_curenta:hover {
                    font-size: 18px;
                    opacity: 1;
                }

                .button-zi-indisponibila {
                    margin: 0;
                    width: 45px;
                    height: 45px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @zi_indisponibila;
                    color: @zi_indisponibila_text;
                    cursor: not-allowed;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                    opacity: 0.5;
                }

                .button-zi-plina {
                    margin: 0;
                    width: 55px;
                    height: 55px;
                    text-align: center;
                    padding: 0;
                    border-radius: 6px;
                    background-color: @zi_indisponibila;
                    color: @zi_indisponibila_text;
                    cursor: not-allowed;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    align-items: center;
                }
            }

        }


        .weeks {
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 0;
            padding: 10px 0;

            .el-button {
                margin: 10px 0;
                width: 50px;
                height: 50px;
                text-align: center;
                padding: 0;

                span {
                    font-weight: 800 !important;
                }

            }
        }
    }

    .main-formular {
        width: 100%;
        height: 82%;
        overflow: auto;
        padding: 1% 5%;
        border-top: 1px solid @gri;
        border-bottom: 1px solid @gri;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-direction: column;

        .titlu-formular {
            width: 100%;
            margin: 20px 0;
            display: flex;
            justify-content: space-between;
            text-align: start;
            height: 50px;

            h1 {
                font-weight: 400;
                color: @gri_inchis;
                font-size: 14px;
                width: 30%;
                height: 100%;
                cursor: pointer;
            }

            h2 {
                font-weight: 400;
                color: @albastru;
                font-size: 14px;
                width: 30%;
                height: 100%;
                cursor: pointer;
            }

            .selectat {
                border-bottom: 2px solid @albastru;
                font-size: 16px;
                animation: grow .269s;
                color: black;
                font-weight: 500;
            }

            border-bottom: 1px solid @gri_inchis;
        }

        .formular {
            width: 100%;
            margin: 15px 0;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;

            .rand {
                width: 100%;
                display: flex;
                justify-content: flex-start;
            }

            .coloana {
                width: 49%;
                margin: 0 1%;
            }

            .an {
                width: 49%;
                margin: 0 1%;

                .el-date-editor.el-input {
                    width: 100%;
                }
            }

            .an:first-child,
            .coloana:first-child {
                margin-left: 0;
            }

            .an:last-child,
            .coloana:last-child {
                margin-right: 0;
            }
        }

    }

    .footer-formular {
        width: 100%;
        min-height: 10%;
        margin: 0;
        padding: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;

        a {
            color: @albastru;
            font-weight: 600;
            margin: 5px 20px;

        }

        a:hover {
            color: @albastru;
            cursor: pointer;
        }

        .el-button {
            border: none;
            margin: 5px 20px;
            background-color: @albastru;
            color: white;
        }

    }

}


.program_plin {
    background-color: @rosu_deschis;
    border-color: @rosu_deschis;
    color: rgba(0, 0, 0, 0.311);
}

.right-content {
    background-color: #fff;
    width: 28%;

    .header {
        display: flex;
        height: 10%;
        justify-content: flex-start;
        padding: 0 20px;
        align-items: center;

        h1 {
            font-size: 18px;
            color: @albastru;
            width: 100%;
            text-align: end;
            border-bottom: 2.5px dotted @albastru;
            border-top: 2.5px dotted @albastru;
            line-height: 0.1em;
            margin: 10px 0;
        }

        h1 span {
            background: #fff;
            padding: 0 10px;
            margin: 0 30px
        }
    }

    .main {
        width: 100%;
        height: 80%;
        border-top: 1px solid @gri;
        border-bottom: 1px solid @gri;
        padding: 0 15px;
        display: grid;
        justify-content: center;
        grid-template-columns: repeat(2, 45%);
        grid-template-rows: repeat(3, 60px);
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        justify-content: flex-start;
        flex-wrap: wrap;
        flex-direction: column;

        .element {
            width: 100%;
            height: 80px;
            text-align: left;
            animation: ToTopOrar 0.2s;
            padding: 15px 0;
            border-bottom: 1px solid @gri;

            h3 {
                font-size: 10px;
                color: @gri_inchis;
                font-weight: 600;
                margin: 0;
            }

            h1 {
                font-size: 14px;
                color: @albastru;
                font-weight: 600;
            }
        }
    }
}

@media only screen and (max-width: 1500px) {
    .content {
        width: 80%;
        height: 80%;
    }
}

@media only screen and (max-width: 780px) {
    .el-card__body{
        padding: 0px !important;
    }
    .el-card__header{
        padding: 0px !important;
        padding-bottom:8px !important
    }
    // .rezervari, html {
    //     height: 85vh;
    // }
    .content {
        background-color: #fff;
        width: 100% !important;
        height: 100% !important;
        border-radius: 0px;
        box-shadow: none;
        margin: 0;
        padding: 0;
        flex-direction: column;
        justify-content: center;

    }

    .left-content,
    .right-content {
        display: none;
    }

    .center-content {
        width: 100% !important;
        height: 100% !important;
        overflow: hidden;
        padding: 0;

        .header {
            height: 10% !important;
        }

        .main {
            height: 80% !important;
        }

        .footer {
            height: 10% !important;
        }

        .program {
            grid-template-columns: repeat(7, 14%) !important;

            .zi {
                width: 90% !important;
            }
        }

        .main-ora {
            overflow: hidden;
            overflow-y: scroll;
            height: 84%;
        }

        .footer-ora {
            height: 3%;
        }

        .ore {
            display: flex;
            justify-content: center;
            padding: 0 5px;
            align-items: center;

            .butoane {
                margin: 0;
                align-items: center;
                justify-content: space-evenly !important;
                margin: 0 auto;
            }
        }

        .titlu-formular {
            .selectat {
                font-size: 18px !important;

            }

            h1 {
                font-size: 14px !important;


            }
        }

        .formular {
            .rand {
                flex-direction: column;

                .coloana {
                    margin: 0;
                    width: 100% !important;
                }

                .an {
                    width: 100% !important;

                    .el-date-editor.el-input,
                    .el-date-editor.el-input__inner {
                        width: 100% !important;
                        margin: 0;
                    }
                }
            }
        }
    }

    .select-container {
        .serviciu {
            h1 {
                font-size: 20px !important;
            }

            h4 {
                font-size: 14px !important;
            }
        }

        .pret {
            h1 {
                font-size: 18px !important;
            }

            h4 {
                font-size: 12px !important;
            }
        }
    }


}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
}

@keyframes FromTop {
    0% {
        margin-top: 20%;
    }

    100% {
        margin-top: 20px;
    }
}

@keyframes ToTopOrar {
    0% {
        margin-top: 20%;
    }

    100% {
        margin-top: 0;
    }
}

@keyframes grow {
    0% {
        font-size: 14px;
    }


    100% {
        font-size: 16px;
    }
}

.el-tag {
    margin-right: 8px; 
    margin-bottom: 8px;
}
</style>